export const getPriceWithoutDiscount = (product: any) => {
  const priceValues = [
    product?.priceWithoutDiscount2,
    product?.priceWithoutDiscount1,
  ]

  for (const value of priceValues) {
    if (typeof value === 'string' && parseFloat(value) !== 0) {
      return parseFloat(value)
    }

    if (typeof value === 'number' && value !== 0) {
      return value
    }
  }

  return 0
}
